var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepingMaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "62px",
    viewBox: "0 0 144 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.7177535%",
    y1: "61.0245648%",
    x2: "53.8653938%",
    y2: "37.833181%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.25,4.03824973 L80.8603538,5.39335322 C81.9527435,5.44898198 83.0472565,5.44898198 84.1396462,5.39335322 L110.75,4.03824973 C125.577744,3.28316292 138.210124,14.6913055 138.965211,29.5190493 C138.9884,29.9744157 139,30.4302984 139,30.8862549 L139,33.2940776 C139,45.8082824 128.855233,55.9530498 116.341028,55.9530498 C114.45546,55.9530498 112.577266,55.717692 110.75,55.2524343 L101.000084,52.7699148 C88.8603631,49.6789039 76.1396369,49.6789039 63.9999156,52.7699148 L54.25,55.2524343 C42.1227345,58.3402737 29.7884549,51.012371 26.7006155,38.8851054 C26.2353578,37.0578397 26,35.1796451 26,33.2940776 L26,30.8862549 C26,16.0392975 38.035837,4.00346054 52.8827944,4.00346054 C53.3387509,4.00346054 53.7946336,4.01506069 54.25,4.03824973 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.3%",
    y: "-0.7%",
    width: "100.7%",
    height: "101.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.374879998,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-3",
    transform: "translate(-955.000000, -1177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(854.000000, 1062.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(102.252160, 115.325058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8242925,51.3301028 C9.78628515,53.5465853 6.27960922,50.8695602 11.3042647,43.2990278 C18.841248,31.9432291 8.68270533,27.6013061 2.45650178,31.275241 C-3.76970177,34.9491758 2.12880685,48.0757595 16.8750784,40.5104854 C31.62135,32.9452114 33.5264052,30.2420415 56.4650499,43.6018047 C71.7574797,52.5083135 60.2105605,55.0844128 21.8242925,51.3301028 Z",
    id: "Path-44",
    stroke: "#575756",
    strokeWidth: 1.49951999,
    transform: "translate(31.500000, 41.500000) scale(1, -1) translate(-31.500000, -41.500000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    x: 21,
    y: 27,
    width: 4,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75,0.0441343074 L79.3673652,1.52927044 C81.4541655,1.64570505 83.5458345,1.64570505 85.6326348,1.52927044 L112.25,0.0441343074 C127.789276,-0.822891425 141.089212,11.0713177 141.956237,26.6105938 C141.985407,27.133382 142,27.6568815 142,28.1804828 L142,36.5510244 C142,49.5014795 131.501582,59.9998976 118.551127,59.9998976 C116.42133,59.9998976 114.301461,59.7097383 112.25,59.1374242 L102.647377,56.4584958 C89.4674337,52.7815711 75.5325663,52.7815711 62.3526235,56.4584958 L52.75,59.1374242 C40.2758758,62.6174404 27.3424896,55.3262753 23.8624734,42.8521512 C23.2901593,40.8006902 23,38.6808215 23,36.5510244 L23,28.1804828 C23,12.6170372 35.6166655,0.00037176673 51.180111,0.00037176673 C51.7037123,0.00037176673 52.2272119,0.0149649459 52.75,0.0441343074 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "1.499519920349121,2.999039840698242"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F8F8F8",
    strokeWidth: 0.749759996,
    xlinkHref: "#path-2"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepingMaskIcon);
export default __webpack_public_path__ + "static/media/sleeping-mask-icon.14897252500c6f955a175adf4a136d3e.svg";
export { ForwardRef as ReactComponent };